import React from 'react';
import { Typography, Button, Grid, Paper, IconButton } from '@mui/material';
import { Facebook, Twitter, LinkedIn, WhatsApp, Instagram, TikTok } from '@mui/icons-material';
import axios from 'axios'; // Import axios for making HTTP requests
import CustomerLayout from '../CustomerLayout'; // ✅ Adjust path if needed

const SocialSharing = () => {
  // Function to handle sharing on Facebook
  const shareOnFacebook = async () => {
    try {
      // Call the backend endpoint to log the Facebook share event
      await axios.post('/api/social-share/log-facebook');
      console.log('Sharing on Facebook');
    } catch (error) {
      console.error('Error sharing on Facebook:', error);
    }
  };

  // Function to handle sharing on Instagram
  const shareOnInstagram = async () => {
    try {
      // Call the backend endpoint to log the Instagram share event
      await axios.post('/api/social-share/log-instagram');
      console.log('Sharing on Instagram');
    } catch (error) {
      console.error('Error sharing on Instagram:', error);
    }
  };

  // Function to handle sharing on Twitter
  const shareOnTwitter = async () => {
    try {
      // Call the backend endpoint to log the Twitter share event
      await axios.post('/api/social-share/log-twitter');
      console.log('Sharing on Twitter');
    } catch (error) {
      console.error('Error sharing on Twitter:', error);
    }
  };

  // Function to handle sharing on LinkedIn
  const shareOnLinkedIn = async () => {
    try {
      // Call the backend endpoint to log the LinkedIn share event
      await axios.post('/api/social-share/log-linkedin');
      console.log('Sharing on LinkedIn');
    } catch (error) {
      console.error('Error sharing on LinkedIn:', error);
    }
  };

  // Function to handle sharing on WhatsApp
  const shareOnWhatsApp = async () => {
    try {
      // Call the backend endpoint to log the WhatsApp share event
      await axios.post('/api/social-share/log-whatsapp');
      console.log('Sharing on WhatsApp');
    } catch (error) {
      console.error('Error sharing on WhatsApp:', error);
    }
  };

  return (
    <CustomerLayout>
    <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px', textAlign: 'center' }}>
      <Typography variant="h4" style={{ marginBottom: '20px' }}>Social Sharing</Typography>

      {/* Social Media Icons for Sharing */}
      <Grid container spacing={2} justifyContent="center" style={{ marginBottom: '20px' }}>
        <Grid item xs={2} sm={1}>
          <IconButton color="primary" onClick={shareOnFacebook}>
            <Facebook fontSize="large" />
          </IconButton>
        </Grid>

        <Grid item xs={2} sm={1}>
          <IconButton color="primary" onClick={shareOnInstagram}>
            <Instagram fontSize="large" />
          </IconButton>
        </Grid>

        <Grid item xs={2} sm={1}>
          <IconButton color="primary" onClick={shareOnTwitter}>
            <Twitter fontSize="large" />
          </IconButton>
        </Grid>

        <Grid item xs={2} sm={1}>
          <IconButton color="primary" onClick={shareOnLinkedIn}>
            <LinkedIn fontSize="large" />
          </IconButton>
        </Grid>
        
        <Grid item xs={2} sm={1}>
          <IconButton color="primary" onClick={shareOnWhatsApp}>
            <WhatsApp fontSize="large" />
          </IconButton>
        </Grid>

        {/* Include icons and handlers for other social media platforms... */}
      </Grid>

      {/* Share Button */}
      <Button variant="contained" color="primary" sx={{ width: '14rem' }}>
        Share Your Experience
      </Button>

      {/* JSX code... */}
    </Paper>
    </CustomerLayout>
  );
};

export default SocialSharing;
